import React from "react";
import { Box, Container, Paper, Typography, Stack } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Header } from "../../components/Header";
import QorSavedCards from "../../components/Checkout/QorSavedCards";

/**
 * Payment Methods — the customer's saved QorCommerce cards. View + remove.
 * New cards are added by choosing "Save this card" during checkout. Reuses the
 * QorSavedCards component in manageOnly mode (list + delete, no selection).
 */
export default function PaymentMethods() {
  return (
    <>
      <Header />
      <Container maxWidth="sm" sx={{ mt: 4, mb: 6 }}>
        <Paper elevation={0} sx={{ p: { xs: 2.5, md: 3 }, borderRadius: "20px", border: "1px solid #e5e7eb" }}>
          <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1 }}>
            <CreditCardIcon sx={{ color: "#FF3008" }} />
            <Typography sx={{ fontSize: "1.15rem", fontWeight: 800, color: "#0f172a" }}>
              Payment Methods
            </Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Your saved cards. To add a card, choose &quot;Save this card for next
            time&quot; when you pay for an order.
          </Typography>
          <Box>
            <QorSavedCards manageOnly />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
